<template>
  <div class="study_question_container v2_study_question_section">
    <!--   JOB QUESTION SECTION   -->
    <ico-question-block :job-question="jobQuestion" />
    <div
        :class= "jobQuestion && jobQuestion.type !== 'GEOGRAPHY' ? 'job-question-block' : ''"
    >
      <!--   JOB ANSWER SECTION   -->
      <div class="">
        <b-row>
          <b-col cols="12" class="pb-1 mt-2" v-if="!jobQuestion.required">
            <b-form-checkbox
              :checked="noPreferenceValue"
              :value="1"
              :unchecked-value="0"
              @change="onUpdateNoPreference(jobQuestion.id, $event)"
            >
              No preference
            </b-form-checkbox>
          </b-col>
        </b-row>
        <preference-chart-input
          ref="preference_input"
          :job-question="jobQuestion"
          :for-question-form="true"
          :study-question="studyQuestion"
          :no-preference-value="noPreferenceValue"
          @set-preference="onSetJobQuestion"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PreferenceChartInput from '@/components/exchange/job-profile-details/PreferenceChartInput';
import IcoQuestionBlock from '@/components/study/form/ico-question/IcoQuestionBlock';
import cloneDeep from 'lodash/cloneDeep';
import {
  getTypeAndValueFromGeographicQuestion,
  isJobQuestionAnswered,
} from '@/helpers/jobQuestionsHelper';
import { JOB_QUESTION_TYPES } from '@/store';
import {compareQuestionVarsByOrder} from "@/helpers/questionnaireHelper";

export default {
  name: 'IcoStudyQuestion',
  props: {
    initialJobQuestion: Object,
    studyQuestion: Object,
    defaultJobProfile: Object,
  },
  components: {
    PreferenceChartInput,
    IcoQuestionBlock,
  },
  data: function () {
    const jobQuestion = cloneDeep(this.initialJobQuestion);
    jobQuestion.jobQuestionVariables.sort(compareQuestionVarsByOrder);
    return {
      jobQuestion: jobQuestion,
    };
  },
  computed: {
    noPreferenceValue: function () {
      const variable = this.jobQuestion.jobQuestionVariables[0];
      const response = variable
        ? (variable.jobProfileQuestionResponses || [])[0]
        : null;
      return (response || {}).declined;
    },
  },
  methods: {
    isJobQuestionAnswered: function () {
      return isJobQuestionAnswered(this.jobQuestion);
    },
    updateJobQuestionPreference: function (variableId, value) {
      const varIndex = this.jobQuestion.jobQuestionVariables.findIndex(
        (jQv) => jQv.id === variableId
      );
      if (varIndex > -1) {
        this.updateJobQuestionResponseByJobQuestionVarIndex(
          varIndex,
          'value',
          value
        );
      }
    },
    updateSelectOnePreference: function (variableId) {
      this.jobQuestion.jobQuestionVariables.forEach((jQv, index) => {
        this.updateJobQuestionResponseByJobQuestionVarIndex(
          index,
          'value',
          jQv.id === variableId ? 1 : 0
        );
      });
    },
    updateYesNoPreference: function (value) {
      this.updateJobQuestionResponseByJobQuestionVarIndex(0, 'value', value);
    },
    updateNoPreference: function (jobQuestionId, value) {
      if (jobQuestionId !== this.jobQuestion.id) return;
      if (this.jobQuestion.jobQuestionVariables[0]) {
        this.updateJobQuestionResponseByJobQuestionVarIndex(
          0,
          'declined',
          value
        );
      }

      if (value === 1) {
        this.jobQuestion.jobQuestionVariables.forEach((variable) => {
          this.$set(variable.jobProfileQuestionResponses[0], 'value', null);
        });
      } else if (value === 0) {
        this.jobQuestion.jobQuestionVariables.forEach((variable) => {
          this.$set(variable.jobProfileQuestionResponses[0], 'value', 0);
        });
      }
    },
    onUpdateNoPreference: function (jobQuestionId, value) {
      this.updateNoPreference(jobQuestionId, value);
      this.$emit('job-question-updated');
    },
    updateJobQuestionResponseByJobQuestionVarIndex: function (
      varIndex,
      valueKey,
      value
    ) {
      this.$set(
        this.jobQuestion.jobQuestionVariables[varIndex]
          .jobProfileQuestionResponses[0],
        valueKey,
        value
      );
      if (
        !this.jobQuestion.jobQuestionVariables[varIndex]
          .jobProfileQuestionResponses[0].job_profile_id &&
        this.defaultJobProfile
      ) {
        this.$set(
          this.jobQuestion.jobQuestionVariables[varIndex]
            .jobProfileQuestionResponses[0],
          'job_profile_id',
          this.defaultJobProfile.id
        );
      }
    },
    onGeographyPreferenceUpdate: async function (newValue) {
      this.$set(
        this.jobQuestion.jobQuestionVariables[0].jobProfileQuestionResponses,
        '0',
        newValue
      );
      const { type, value } = getTypeAndValueFromGeographicQuestion(
        this.jobQuestion
      );
      const updatedProfile = {
        ...this.defaultJobProfile,
        geographic_preference_type: type,
        geographic_preference_value: value ? JSON.stringify(value) : null,
      };
      this.$emit('update-job-profile', updatedProfile);
    },
    onUpdateJobQuestionPreference: function (...rest) {
      switch (this.jobQuestion.type) {
        case JOB_QUESTION_TYPES.SLIDER:
        case JOB_QUESTION_TYPES.RATING:
        case JOB_QUESTION_TYPES.SELECT_ANY:
        case JOB_QUESTION_TYPES.MULTI_VARIABLE_SELECT_ONE:
          this.updateJobQuestionPreference(...rest);
          this.updateNoPreference(this.jobQuestion.id, null);
          break;
        case JOB_QUESTION_TYPES.SELECT_ONE:
          this.updateSelectOnePreference(...rest);
          this.updateNoPreference(this.jobQuestion.id, null);
          break;
        case JOB_QUESTION_TYPES.YES_NO:
          this.updateYesNoPreference(...rest);
          this.updateNoPreference(this.jobQuestion.id, null);
          break;
        case JOB_QUESTION_TYPES.GEOGRAPHY:
          this.onGeographyPreferenceUpdate(...rest);
      }
    },
    onSetJobQuestion: function (...params) {
      this.onUpdateJobQuestionPreference(...params);
      this.$emit('job-question-updated', ...params);
    },
    getJobQuestionData: function () {
      return this.jobQuestion;
    },
  },
};
</script>

<style scoped>
@media (min-width: 320px) and (max-width: 768px){
  .study_question_container{
    padding-left: 10px !important;
    padding-right: 10px !important;
    padding-bottom: 10px;
  }
}
</style>

<style lang="scss" scoped>
@import '../../../../../sass/variables_mixins.scss';
.ico-block-label {
  background: $phairify_v2_color_teal 0 0 no-repeat padding-box;
  border-radius: 8px 8px 0 0;
  text-align: left;
  font: normal normal 600 16px/20px;
  letter-spacing: 0;
  color: $phairify_v2_color_white;
  opacity: 1;
  .mdi.mdi-account {
    font-size: 22px;
  }
}
.job-question-block {
  margin-top: 10px;
  border: 1px solid #AAB0B3;
  padding: 25px;
}
.study_question_container {
  padding-left: 40px;
  padding-right: 40px;
  background-color: #F7FAFA;
  max-width: 1420px;
}
</style>
